export const Order = () => {
	$(document).ready(() => {
		setupFileFields();
		setupBrokerSelect();
		setupVisibleToUserToggle();
	});
};

const clearFileField = (selector) => {
	$(selector).val("");
};

const setupFileFields = () => {
	const $clearFileFields = $(".clear_file_field");
	$clearFileFields.each(function () {
		$(this).on("click", () => clearFileField($(this).data("field")));
	});
};

const updateReportFields = (brokerValue) => {
	const isIB = brokerValue === "interactive_brokers";
	const $ibFields = $(".broker-reports-ib");
	const $ffFields = $(".broker-reports-ff");

	$ibFields.toggle(isIB);
	$ffFields.toggle(!isIB);

	if (!isIB) {
		$ibFields.find('input[type="file"]').val("");
	} else {
		$ffFields.find('input[type="file"]').val("");
	}
};

const setupBrokerSelect = () => {
	const $brokerSelect = $("#order_broker");
	if (!$brokerSelect.length) return;

	updateReportFields($brokerSelect.val());
	$brokerSelect.on("change", function () {
		updateReportFields($(this).val());
	});
};

const setupVisibleToUserToggle = () => {
	const $userSelect = $("select[data-creator-id]");
	const $flag = $("#order_visible_to_user_input");
	const $hint = $("#order-visible-to-user-hint");
	if (!$userSelect.length || !$flag.length || !$hint) return;

	const creatorId = String($userSelect.data("creatorId"));
	const toggleVisibleToUser = () => {
		$flag.toggle($userSelect.val() !== creatorId);
		$hint.toggle($userSelect.val() !== creatorId);
	};

	toggleVisibleToUser();
	$userSelect.on("change", toggleVisibleToUser);
};
